import { Col, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'antd';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HeadingBack from '../../../component/HeadingBack';
import { usePermission } from '../../../hooks/usePermission';
import { DashboardServices } from '../../../redux/Services';
import AbhaLinkedFilter from '../AbhaFilter';
import moment from 'moment';    
import { UserId } from '../../../utils';

const DataRequestPending = () => {
    const permission = usePermission("HIU Dashboard", "List");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const DataRequestSentLogs = useSelector(state => state.dashboard.DataPendingLogs || []);
    const totalDataRequestSentLogs = useSelector(state => state.dashboard.totalDataPendingLogs || 0);
    const { mutate: fetchDataRequestSentLogs, isLoading } = useMutation((data) => dispatch(DashboardServices.fetchDataPendingLogs(data)));

    const [modal1Open, setModal1Open] = useState(false);
    const [raw, setRaw] = useState({  });
    const user={
    UserId:UserId
}
    const [values, setValues] = useState({
        healthId: "",
    });
    const patientDetail = () => {
        let params = {
            healthId:values.healthId,
            UserId:UserId
        }
       
      };

    const handleChange = (name, value) => {
        setValues({ ...values, [name]: value });
    }

    useEffect(() => {
        fetchDataRequestSentLogs({...filter, searchString:undefined});
        return () => { }
    }, [filter])
   
    // const patientDetail = () => {
    //     navigate('/hip/report-detail');
    //   };



    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'sno',
            key: 'sno',
            className: 'table_first_col',
            render: (value, item, index) => (page - 1) * 10 + index + 1
        },
        {
            title: 'Log Id',
            dataIndex: 'id',
            key: 'hip_log_id',
            className: 'table_status_col',
        },
        {
            title: 'Log Type',
            dataIndex: 'log_type',
            key: 'log_type',
        },
        {
            title: 'Request Id',
            dataIndex: 'request_id',
            key: 'request_id',
            className: 'text-capitalize',
        },

        {
            title: 'Requester (HIU/HIP)',
            dataIndex: 'requestor',
            key: 'requestor',
            className: 'text-capitalize',
        },

        {
            title: 'Transaction Id',
            dataIndex: 'transactionId',
            key: 'transactionId',
            className: 'abha-link-date',
            render: (value, item, index) => {
                return (
                    <>{JSON.parse(item?.response_raw_data || "{}")?.hiRequest?.transactionId}</>
                )
            }
        },
        {
            title: 'Date Time',
            dataIndex: 'created_at',
            key: 'createdAt',
            className: 'abha-link-date',
            render: (value, item, index) => {
                return (
                    <>{moment.utc(item.created_at).format('DD-MM-YYYY H:mm:ss')}</>
                )
            }
        },

        {
            title: 'Response Data',
            dataIndex: 'Status',
            key: 'Status',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.response_raw_data || "{}")); setModal1Open(true); }} > View</Button>
                )
                
            }
        },
    ];
    return (
        <div>
            <Row gutter={[10, 10]} align={"middle"}>
                <Col span={24}>
                    <HeadingBack title={"Data Request Pending"} subHeading={`Records ${totalDataRequestSentLogs || 0}`} />
                </Col>
                <Col span={24}>
                    <AbhaLinkedFilter filter={filter} setFilter={setFilter} setPage={setPage} searchHide={true}/>
                </Col>
            </Row>
            <div className='tableResponsive mt-10'>
                <Table
                    rowKey={(row) => row?.Id ?? row?.id}
                    className={isLoading ? 'table antd_table no_data_found_hide' : 'table antd_table'}
                    bordered
                    columns={columns}
                    dataSource={Array.isArray(DataRequestSentLogs) && DataRequestSentLogs?.length > 0 ? DataRequestSentLogs : []}
                    pagination={{
                        current: page,
                        pageSize: 10,
                        onChange(current, pageSize) {
                            setPage(current);
                        },
                        hideOnSinglePage: true,
                        /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
                    }}

                />
                <Modal
                    style={{
                        top: 20,
                    }}
                    open={modal1Open}
                    onOk={() => setModal1Open(false)}
                    onCancel={() => setModal1Open(false)}
                    footer={null}
                >
                     <pre>{JSON.stringify(raw, null, 2)}</pre>

                </Modal>
            </div>
        </div>
    )
}

export default DataRequestPending